import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-admin',
  templateUrl: './sidebar-admin.component.html',
  styleUrl: './sidebar-admin.component.scss',
  standalone: false,
})
export class SidebarAdminComponent {
  constructor() {}
}
